import { render, staticRenderFns } from "./PaperStaticModal.vue?vue&type=template&id=f37753aa&"
import script from "./PaperStaticModal.vue?vue&type=script&lang=js&"
export * from "./PaperStaticModal.vue?vue&type=script&lang=js&"
import style0 from "./PaperStaticModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports